import { render } from "./VueCollapsiblePanelGroup.vue?vue&type=template&id=63943e43&scoped=true"
import script from "./VueCollapsiblePanelGroup.vue?vue&type=script&lang=ts"
export * from "./VueCollapsiblePanelGroup.vue?vue&type=script&lang=ts"

import "./VueCollapsiblePanelGroup.vue?vue&type=style&index=0&id=63943e43&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63943e43"

export default script